import './Loading.scss'
import { useAppSelector } from '../../store/hooks';

export default function Loading() {
    const loading = useAppSelector((state) => state.loading.loading)
    if (!loading) return <></>
    return (
        <div className="is-loading">
            <div className="spinner">
                <div className="double-bounce1" />
                <div className="double-bounce2" />
            </div>
        </div>
    );
}